import {
    FETCH_WELLNESS_GOALS,
    FETCH_WELLNESS_GOALS_FETCHING,
    FETCH_WELLNESS_GOALS_SUCCESS,
    FETCH_WELLNESS_GOALS_FAIL,
    UPDATE_WELLNESS_GOALS,
    UPDATE_WELLNESS_GOALS_UPDATING,
    UPDATE_WELLNESS_GOALS_SUCCESS,
    UPDATE_WELLNESS_GOALS_FAIL,
    RESET_WELLNESS_GOALS_UPDATE
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    wellnessGoalsTypes: {},
    wellnessGoalsFetching: false,
    wellnessGoalsFetchFail: false,
    wellnessGoalsUpdating: false,
    wellnessGoalsUpdateSucceed: false,
    wellnessGoalsUpdateFail: false
};

// ======= Fetching Handlers =======
const fetchWellnessGoalsFetching = (state, action) => {
    return {
        wellnessGoalsTypes: {
            ...state.wellnessGoalsTypes
        },
        wellnessGoalsFetching: true,
        wellnessGoalsFetchFail: false
    };
};

const fetchWellnessGoalsSuccess = (state, action) => {
    return {
        wellnessGoalsTypes: {
            ...state.wellnessGoalsTypes,
            [action.calendarDate]: [...action.data]
        },
        wellnessGoalsFetching: false,
        wellnessGoalsFetchFail: false
    };
};

const fetchWellnessGoalsFail = (state, action) => {
    return {
        wellnessGoalsTypes: {
            ...state.wellnessGoalsTypes
        },
        wellnessGoalsFetching: false,
        wellnessGoalsFetchFail: true
    };
};

// ======= Updating Handlers =======
const updateWellnessGoalsUpdating = (state) => {
    return {
        ...state,
        wellnessGoalsUpdating: true,
        wellnessGoalsUpdateSucceed: false,
        wellnessGoalsUpdateFail: false
    };
};

const updateWellnessGoalsSuccess = (state, action) => {
    const oldDailyGoals = state.wellnessGoalsTypes[action.calendarDate];
    const newDailyGoals = [];

    if (oldDailyGoals) {
        oldDailyGoals.map((dailyGoal) => {
            if (dailyGoal.goalType === action.data.goalType) {
                newDailyGoals.push({
                    goalType: action.data.goalType,
                    goalValue: action.data.goalValue
                });
            } else {
                newDailyGoals.push(dailyGoal);
            }
        });
    }

    return {
        wellnessGoalsTypes: {
            ...state.wellnessGoalsTypes,
            [action.calendarDate]: newDailyGoals
        },
        wellnessGoalsUpdating: false,
        wellnessGoalsUpdateSucceed: true,
        wellnessGoalsUpdateFail: false
    };
};

const updateWellnessGoalsFail = (state, action) => {
    return {
        ...state,
        wellnessGoalsUpdating: false,
        wellnessGoalsUpdateSucceed: false,
        wellnessGoalsUpdateFail: true
    };
};

const resetWellnessGoalsUpdateFlags = (state) => {
    return {
        ...state,
        wellnessGoalsUpdating: false,
        wellnessGoalsUpdateSucceed: false,
        wellnessGoalsUpdateFail: false
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_WELLNESS_GOALS_FETCHING]: fetchWellnessGoalsFetching,
    [FETCH_WELLNESS_GOALS_SUCCESS]: fetchWellnessGoalsSuccess,
    [FETCH_WELLNESS_GOALS_FAIL]: fetchWellnessGoalsFail,
    [UPDATE_WELLNESS_GOALS_UPDATING]: updateWellnessGoalsUpdating,
    [UPDATE_WELLNESS_GOALS_SUCCESS]: updateWellnessGoalsSuccess,
    [UPDATE_WELLNESS_GOALS_FAIL]: updateWellnessGoalsFail,
    [RESET_WELLNESS_GOALS_UPDATE]: resetWellnessGoalsUpdateFlags
};

// ======= Default Action =======
export default function wellnessGoals(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchWellnessGoals(calendarDate, evictCache) {
    return {
        type: FETCH_WELLNESS_GOALS,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function updateWellnessGoals(calendarDate, newGoal, currentDate) {
    return {
        type: UPDATE_WELLNESS_GOALS,
        calendarDate: calendarDate,
        newGoal: newGoal,
        currentDate: currentDate
    };
}

export function resetWellnessGoalsUpdate() {
    return {
        type: RESET_WELLNESS_GOALS_UPDATE
    };
}

// ======= Selectors =======
export const getWellnessGoals = (state) => {
    return state.wellnessGoals ? state.wellnessGoals : null;
};

export const isWellnessGoalsFetching = (state) => {
    return state.wellnessGoals.wellnessGoalsFetching;
};

export const didWellnessGoalsFetchFail = (state) => {
    return state.wellnessGoals.wellnessGoalsFetchFail;
};

export const isWellnessGoalsUpdating = (state) => {
    return state.wellnessGoals.wellnessGoalsUpdating;
};

export const didWellnessGoalsUpdateSucceed = (state) => {
    return state.wellnessGoals.wellnessGoalsUpdateSucceed;
};

export const didWellnessGoalsUpdateFail = (state) => {
    return state.wellnessGoals.wellnessGoalsUpdateFail;
};
